import { ToggleType } from '../types';

export default function mapYesNo(toggleType?: ToggleType) {
  if (!toggleType) return undefined;

  return toggleType === 'yes' ? 'Ja' : 'Nee';
}
